<template>
  <div
    class="gallery-thumbnail-overlay"
    :style="{
      backgroundColor,
    }"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "GalleryThumbnailOverlay",
  props: {
    backgroundColor: {
      type: String,
      required: true,
    },
  },
})
</script>

<style scoped>
.gallery-thumbnail-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: inherit;
}
</style>
